import { Button, Container, Form, FormField } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import { CustomAppLayout } from '../../../layout';
import { useStore } from '../../../store';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import * as XLSX from "xlsx";
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;



export const DownloadsMantsPage = () => {
    const { menu, parameters } = useGlobalState();

    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const handleRefreshMovements = async () => {
        if (parameters.period) {

            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/mants/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        month: parameters.period.split("-")[1],
                        year: parameters.period.split("-")[0],
                        orderBy: "dateSubmited",
                        order: "desc",
                        columns: "idMaintenance, registration, note, answer, isOutOfFlight, dateSubmited, dateAnswer, user, dateNote, dateClosed, statusMant, idEquipment"

                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                if (data.code == 0) {
                    if (data.notes.length === 0) {
                        addNotificationStatus(data, setData);
                    } else {

                        const ws = XLSX.utils.json_to_sheet(data.notes);
                        const wb = XLSX.utils.book_new();
                        XLSX.utils.book_append_sheet(wb, ws, "Notas");
                        XLSX.writeFile(wb, `Mantenimiento.${parameters.period}.xlsx`);
                    }

                } else {
                    addNotificationStatus(data, setData);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }
    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">

                        <Header actions={<Favorites />}>
                            Descarga de archivo de notas de mantenimiento
                        </Header>
                        <Container>
                            <Form >
                                <SpaceBetween direction='horizontal' size='xs'>
                                    <FormField label="Periodo">
                                        <div style={{ width: 130 }}>
                                            <MPModal
                                                width={120}
                                                today prevMonth nextMonth
                                                end={new Date()}
                                                date={`${parameters.period}`}
                                                onConfirm={(date) => {
                                                    setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                                }}
                                            />
                                        </div>
                                    </FormField>
                                    <FormField label="&nbsp;">
                                        <Button onClick={handleRefreshMovements} style={{ root: btnIconForm }} disabled={parameters.year === "" || parameters.month === ""}><Icon path={mdiFileExcel} size={1} /></Button>
                                    </FormField>

                                </SpaceBetween>
                            </Form>
                        </Container>
                    </SpaceBetween>
                </>
            }
        />
    );
};
